import React, { FC, ReactNode } from 'react';
import { Infobox } from 'ui-library';
import './WidgetError.css';

interface WidgetErrorProps {
    /** The error message to display, can be a single string or an array of messages */
    message?: string | (string | ReactNode)[];
    /** Supports additional props passed to the Infobox component */
    [key: string]: any;
}

const WidgetError: FC<WidgetErrorProps> = ({
    message = '',
    ...props
}) => {
    const renderMessage = () => {
        if (typeof message === 'string') {
            return message;
        }

        if (Array.isArray(message)) {
            return message.map((item, index) => (
                item ? (
                    <div key={`error-msg-${index}`}>
                        {item}
                    </div>
                ) : null
            ));
        }

        return null;
    };

    return (
        <Infobox {...props}>
            <div className="widget-error__content">
                {renderMessage()}
            </div>
        </Infobox>
    );
};

export default WidgetError;
